// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falCircleExclamation: CreateIconOptions = {
  "displayName": "FALCircleExclamation",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
};
